import map from 'lodash/map'
import numeral from 'numeral'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import {
  compassUpdate,
  customerUpdate,
  phaseChange,
  privacyUpdate,
  putComapassCallback,
  putCompass,
  reroute,
  storeDumpItForce,
} from '../../../actions/Buy'
import { putClienti, putClientiCallback } from '../../../actions/buy/Clienti'
import {
  getTabelleDominioCompass,
  getTabelleDominioCompassCallbackOccupazioneAttivita,
  getTabelleDominioCompassCallbackSettoreAttivita,
} from '../../../actions/buy/Compass'
import verify from '../../../modules/verify'
import fbpixel, { FB_EVENTS } from '../../../utils/fbpixel'
import { transformComuniResidenzaV2Result } from '../../../utils/searchComuniUtils'
import PhoneInput from '../../Input/Phone'
import DocumentiHelperModal from '../../noleggia/dumb/DocumentiHelperModal'
import {
  CRITEO_EVENTS,
  EVENT_TYPES,
  triggerClickStreamEvent,
} from '../../triggerDataLayerEvent'
import BuyCheckboxInput2 from '../dumb/BuyCheckboxInput2'
import BuyDataForm from '../dumb/BuyDataForm'
import BuyDateInput from '../dumb/BuyDateInput'
import BuyRadioInput from '../dumb/BuyRadioInput'
import BuySelectInput2 from '../dumb/BuySelectInput2'
import BuyTextInput from '../dumb/BuyTextInput'
import BuyTextInput2 from '../dumb/BuyTextInput2'
import {
  haGaranzia3Anni,
  mapfreAssistenzaStradale,
  mapfreInformativaDatiPersonali,
  mapfreProgrammaGaranzia,
} from '../utils'

class BuyDataFormFinancement extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.state.section = 1
    this.state.show_condizioni_generali_di_contratto_modal = false
    this.state.show_termini_di_utilizzo_modal = false
    this.state.toTop = false
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.handleRadio = this.handleRadio.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.handlePrev = this.handlePrev.bind(this)
    this.against_map = this.against_map.bind(this)
    this.buildPutCompassBody = this.buildPutCompassBody.bind(this)
    this.residenzaPrecendenteRequired =
      this.residenzaPrecendenteRequired.bind(this)
    this.validation_map_dati_personali =
      this.validation_map_dati_personali.bind(this)
    this.validation_map_residenza_e_domicilio =
      this.validation_map_residenza_e_domicilio.bind(this)
    this.validation_map_conto_corrente =
      this.validation_map_conto_corrente.bind(this)
    this.validation_map_privacy = this.validation_map_privacy.bind(this)
    this.validate = this.validate.bind(this)
    this.state.cap_residenza = this.props.customer.cap_residenza || null
    this.state.caps_residenza = this.props.customer.caps_residenza || []
    this.state.select_cap_residenza =
      this.props.customer.select_cap_residenza || false
    this.state.cap_domicilio = this.props.customer.cap_domicilio || null
    this.state.caps_domicilio = this.props.customer.caps_domicilio || []
    this.state.select_cap_precedente =
      this.props.compass.select_cap_precedente || false
    this.state.cap_precedente = this.props.compass.cap_precedente || null
    this.state.caps_precedente = this.props.compass.caps_precedente || []
    this.state.select_cap_lavoro = this.props.compass.select_cap_lavoro || false
    this.state.cap_lavoro = this.props.compass.cap_lavoro || ''
    this.state.caps_lavoro = this.props.compass.caps_lavoro || []
    this.state.documento = this.props.customer.documento || ''
    this.state.dati_cliente_phone_error = ''
    this.state.dati_compass_politicamente_esposto_error = ''
    this.state.dati_compass_stato_civile_error = ''
    this.state.dati_cliente_documento_error = ''
    this.state.dati_cliente_numero_documento_error = ''
    this.state.dati_cliente_partita_iva_error = ''
    this.state.dati_cliente_ente_rilascio_documento_error = ''
    this.state.dati_cliente_data_rilascio_documento_error = ''
    this.state.dati_compass_cittadinanza_error = ''
    this.state.dati_cliente_tipo_permesso_soggiorno_error = ''
    this.state.dati_cliente_data_rilascio_permesso_soggiorno_error = ''
    this.state.dati_cliente_data_scadenza_permesso_soggiorno_error = ''
    this.state.dati_compass_data_scadenza_contratto_error = ''
    this.state.dati_compass_situazione_abitativa_error = ''
    this.state.dati_cliente_citta_residenza_error = ''
    this.state.dati_cliente_cap_residenza_error = ''
    this.state.dati_cliente_indirizzo_residenza_error = ''
    this.state.dati_cliente_numero_civico_residenza_error = ''
    this.state.dati_compass_residente_dal_error = ''
    this.state.dati_cliente_domicilio_diverso_error = ''
    this.state.dati_compass_membri_familiari_error = ''
    this.state.dati_compass_familiari_con_reddito_error = ''
    this.state.dati_compass_comune_precedente_error = ''
    this.state.dati_compass_cap_precedente_error = ''
    this.state.dati_compass_indirizzo_precedente_error = ''
    this.state.dati_compass_civico_precedente_error = ''
    this.state.dati_cliente_citta_domicilio_error = ''
    this.state.dati_cliente_cap_domicilio_error = ''
    this.state.dati_cliente_indirizzo_domicilio_error = ''
    this.state.dati_cliente_civico_domicilio_error = ''
    this.state.dati_compass_tipo_attivita_error = ''
    this.state.dati_compass_settore_error = ''
    this.state.dati_compass_occupazione_error = ''
    this.state.dati_compass_reddito_error = ''
    this.state.dati_compass_data_inizio_attivita_error = ''
    this.state.dati_compass_datore_lavoro_error = ''
    this.state.dati_compass_telefono_fisso_lavoro_error = ''
    this.state.dati_compass_telefono_fisso_personale_error = ''
    this.state.dati_compass_comune_lavoro_error = ''
    this.state.dati_compass_cap_lavoro_error = ''
    this.state.dati_compass_indirizzo_lavoro_error = ''
    this.state.dati_compass_civico_lavoro_error = ''
    this.state.dati_compass_tipo_conto_corrente_error = ''
    this.state.dati_compass_data_apertura_conto_error = ''
    this.state.dati_compass_altre_carte_error = ''
    this.state.dati_compass_iban_error = ''
    this.state.dati_compass_privacy_obbligatoria_1_mag2018_error = ''
    this.state.dati_compass_privacy_facoltativa_1_error = ''
    this.state.dati_compass_privacy_facoltativa_2_error = ''
    this.state.dati_compass_privacy_facoltativa_3_error = ''
    this.state.dati_compass_presa_visione_obbligatoria_error = ''
    this.state.dati_compass_condizioni_brumbrum_obbligatorie_error = ''
    this.state.dati_cliente_informativa_trattamento_dati_personali_garanzia_error =
      ''
    this.state.dati_cliente_fatturazione_uguale_error = ''
    this.state.dati_cliente_cap_fatturazione_error = ''
    this.state.dati_cliente_indirizzo_fatturazione_error = ''
    this.state.dati_cliente_numero_civico_fatturazione_error = ''
    this.state.dati_cliente_ragione_sociale_error = ''
    this.state.caps_fatturazione = this.props.customer.caps_fatturazione || []
    this.state.cap_fatturazione = this.props.customer.cap_fatturazione || ''
    this.state.select_cap_fatturazione =
      this.props.customer.select_cap_fatturazione || false
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register', true)
    }
    if (this.props.customer) {
      map(this.props.customer, (value, key) => {
        if (typeof value === 'string') {
          this.validate(`dati_cliente_${key}`, value)
        }
      })
    }
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 30 })

    if (!this.state.toTop) {
      animateScroll.scrollToTop()
      this.setState({ toTop: true })
    }

    if (
      (!('settoreattivita' in this.props.compass_tabelledominio) ||
        this.props.compass_tabelledominio.settoreattivita === null ||
        this.props.compass_tabelledominio.settoreattivita.length === 0) &&
      'token' in this.props.customer &&
      this.props.customer.token !== null
    ) {
      this.props
        .getTabelleDominioCompass({
          section: 'settoreattivita/1',
          token: this.props.customer.token,
          callback: this.props.getTabelleDominioCompassCallbackSettoreAttivita,
        })
        .catch(() => null)
    }

    if (
      (!('occupazioneattivita' in this.props.compass_tabelledominio) ||
        this.props.compass_tabelledominio.occupazioneattivita === null ||
        Object.keys(this.props.compass_tabelledominio.occupazioneattivita)
          .length === 0) &&
      'token' in this.props.customer &&
      this.props.customer.token !== null
    ) {
      this.props
        .getTabelleDominioCompass({
          section: 'occupazioneattivita/1',
          token: this.props.customer.token,
          callback:
            this.props.getTabelleDominioCompassCallbackOccupazioneAttivita,
        })
        .catch(() => null)
    }

    this.props.storeDumpItForce()
    triggerClickStreamEvent(
      CRITEO_EVENTS.BASKET_FUNNEL_PERSONAL_DATA,
      EVENT_TYPES.CRITEO,
      {
        email: this.props.customer.email,
        idAuto: this.props.product.id_auto,
        price: numeral(
          this.props.ordine.totale - this.props.ordine.acconti
        ).format('$ 0,0[.]00'),
      }
    )
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.error.display === true &&
      this.props.error.display === false
    ) {
      // l'utente ha chiuso il popup di errore
      this.handlePrev()
    }
  }

  validate(label, value, compassHandler = null, requireAttention = false) {
    const v = verify(label, value, this.against_map(label))
    const t = this
    const new_state = {}
    if (v.is_required || !v.is_valid) {
      new_state[`${label}_error`] = v.is_required ? ' is-required' : ' is-error'
    } else {
      new_state[`${label}_error`] = ' is-ok'
    }
    Object.keys(v.updates.states).forEach(key => {
      new_state[key] = v.updates.states[key]
    })
    this.setState(new_state)
    Object.keys(v.updates.stores).forEach(key => {
      const updateHandler =
        compassHandler !== null ? compassHandler : t.props.customerUpdate
      updateHandler({
        [key]: v.updates.stores[key],
      })
    })
    this.setState(new_state, () => {
      if (
        requireAttention &&
        document.querySelectorAll('.is-error, .is-required').length > 0
      ) {
        animateScroll.scrollTo(
          document.querySelectorAll('.is-error, .is-required')[0].offsetTop -
            95,
          {
            smooth: true,
            dynamic: true,
          }
        )
      }
    })
    return v
  }

  handleInput(label, compassHandler = null) {
    const t = this
    return function (event) {
      const validate_label_prefix =
        compassHandler !== null ? 'dati_compass_' : 'dati_cliente_'
      const v = t.validate(
        validate_label_prefix + label,
        event.target.value,
        compassHandler
      )

      const updateHandler =
        compassHandler !== null ? compassHandler : t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
    }
  }

  handleSelect(label, compassHandler = null) {
    const t = this
    return function (selected) {
      const validate_label_prefix =
        compassHandler !== null ? 'dati_compass_' : 'dati_cliente_'
      const v = t.validate(
        validate_label_prefix + label,
        selected ? selected.value : '',
        compassHandler
      )

      const updateHandler =
        compassHandler !== null ? compassHandler : t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
    }
  }

  handleRadio(label, compassHandler = null) {
    const t = this
    return function (event) {
      const validate_label_prefix =
        compassHandler !== null ? 'dati_compass_' : 'dati_cliente_'
      const v = t.validate(
        validate_label_prefix + label,
        event.target.value,
        compassHandler
      )

      const updateHandler =
        compassHandler !== null ? compassHandler : t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })

      if (label === 'documento') {
        t.setState({ [label]: v.value })
      }
    }
  }

  handleCheckbox(label, compassHandler = null) {
    const t = this
    return function (event) {
      const validate_label_prefix =
        compassHandler !== null ? 'dati_compass_' : 'dati_cliente_'
      let v

      if (label === 'altre_carte') {
        let altre_carte = []
        if (t.props.compass.altre_carte) {
          altre_carte = t.props.compass.altre_carte.splice(0)
        }
        if (event.target.checked) {
          altre_carte.push(event.target.value)
        } else if (altre_carte.indexOf(event.target.value) !== -1) {
          altre_carte.splice(altre_carte.indexOf(event.target.value), 1)
        }
        v = t.validate(
          validate_label_prefix + label,
          altre_carte,
          compassHandler
        )
      } else {
        v = t.validate(
          validate_label_prefix + label,
          event.target.checked,
          compassHandler
        )
      }

      const updateHandler =
        compassHandler !== null ? compassHandler : t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
    }
  }

  handleSubmit() {
    const t = this
    t.props.reroute().then(() => {
      this.props
        .putClienti({
          cliente: this.props.customer,
          token: this.props.customer.token,
          callback: this.props.putClientiCallback,
          error_400: 'dati_non_corretti',
        })
        .then(() => {
          t.props.reroute().then(() => {
            this.props
              .putCompass({
                method: 'POST',
                uri: `${window.brumbrum.url_api}/compass/t/v1/clienti/${this.props.ordine.id_ordine}`,
                body: JSON.stringify(this.buildPutCompassBody()),
                token: this.props.customer.token,
                callback: this.props.putComapassCallback,
                error_400: 'dati_non_corretti',
              })
              .then(() => {
                fbpixel(FB_EVENTS.CompleteRegistration, null, t.props.product)
                t.props.phaseChange({
                  last: t.props.ui.last > 30 ? t.props.ui.last : 30,
                })
                t.props.reroute('/documents-compass')
              })
              .catch(() => {
                t.handlePrev()
              })
          })
        })
        .catch(() => null)
    })
  }

  buildPutCompassBody() {
    const compass = {}
    const t = this

    Object.keys(this.props.compass).forEach(key => {
      const val = t.props.compass[key]
      if (
        [
          'residente_dal',
          'data_inizio_attivita',
          'data_apertura_conto',
          'data_scadenza_contratto',
        ].indexOf(key) > -1
      ) {
        if ('day' in val && 'month' in val && 'year' in val) {
          let month = val.month.toString()
          month = `0${month}`
          month = month.slice(-2)
          let day = val.day.toString()
          day = `0${day}`
          day = day.slice(-2)
          compass[key] = `${day}-${month}-${val.year}`
        }
      } else if (
        (typeof val === 'string' || val instanceof String) &&
        val.indexOf('|') > -1
      ) {
        compass[key] = val.split('|')[0]
        if (key === 'comune_lavoro') {
          compass.codice_provincia_lavoro = val.split('|')[1]
        } else if (key === 'comune_precedente') {
          compass.codice_provincia_precedente = val.split('|')[1]
        }
      } else if (
        key !== 'caps_lavoro' &&
        key !== 'caps_precedente' &&
        key !== 'select_cap_lavoro' &&
        key !== 'select_cap_precedente'
      ) {
        compass[key] = val
      }
    })

    return compass
  }

  against_map(label) {
    const t = this

    const against = {
      dati_cliente_data_rilascio_documento: {
        dati_cliente_data_di_nascita: t.props.customer.data_di_nascita,
      },
      dati_compass_data_inizio_attivita: {
        dati_cliente_data_di_nascita: t.props.customer.data_di_nascita,
      },
      dati_compass_data_apertura_conto: {
        dati_cliente_data_di_nascita: t.props.customer.data_di_nascita,
      },
      dati_compass_residente_dal: {
        dati_cliente_data_di_nascita: t.props.customer.data_di_nascita,
      },
      dati_cliente_data_rilascio_permesso_soggiorno: {
        dati_cliente_data_di_nascita: t.props.customer.data_di_nascita,
      },
      dati_compass_familiari_con_reddito: {
        dati_compass_membri_familiari: t.props.compass.membri_familiari || 0,
      },
      dati_cliente_citta_residenza: {
        dati_cliente_caps_residenza: t.props.customer.caps_residenza || [],
      },
      dati_cliente_citta_domicilio: {
        dati_cliente_caps_domicilio: t.props.customer.caps_domicilio || [],
      },
      dati_compass_comune_precedente: {
        dati_compass_caps_precedente: t.props.compass.caps_precedente || [],
      },
      dati_compass_comune_lavoro: {
        dati_compass_caps_lavoro: t.props.compass.caps_lavoro || [],
      },
      dati_compass_data_scadenza_contratto: {
        dati_ordine_id_finanziamento: t.props.ordine.id_finanziamento,
        dati_finanziamento: t.props.financements.default
          .concat([].concat([t.props.financements.custom]))
          // eslint-disable-next-line
          .filter(n => n != undefined),
      },
      dati_cliente_numero_documento: {
        dati_cliente_documento: t.props.customer.documento || '',
      },
      dati_cliente_citta_fatturazione: {
        dati_cliente_caps_fatturazione:
          t.props.customer.caps_fatturazione || [],
      },
    }

    return against[label]
  }

  validation_map_dati_personali() {
    const t = this
    let validation_map = {
      dati_compass_politicamente_esposto:
        t.props.compass.politicamente_esposto || '0',
      dati_compass_stato_civile: t.props.compass.stato_civile || '',
      dati_cliente_documento: t.props.customer.documento || '',
      dati_cliente_numero_documento: t.props.customer.numero_documento || '',
      dati_cliente_ente_rilascio_documento:
        t.props.customer.ente_rilascio_documento || '',
      dati_cliente_data_rilascio_documento:
        t.props.customer.data_rilascio_documento.raw || '',
      dati_cliente_cittadinanza: t.props.customer.cittadinanza || '',
      dati_cliente_phone: t.props.customer.phone || '',
      dati_compass_telefono_fisso_personale:
        t.props.compass.telefono_fisso_personale || '',
    }

    if (t.props.customer.partita_iva) {
      validation_map = {
        ...validation_map,
        dati_cliente_partita_iva: t.props.customer.partita_iva,
      }
    }

    if (
      this.props.compass_tabelledominio.cittadinanza_is_extra_eu_by_codice[
        this.props.customer.cittadinanza
          ? this.props.customer.cittadinanza.split('|')[0]
          : ''
      ]
    ) {
      validation_map = {
        ...validation_map,
        dati_cliente_data_rilascio_permesso_soggiorno:
          t.props.customer.data_rilascio_permesso_soggiorno.raw || '',
        dati_cliente_data_scadenza_permesso_soggiorno:
          t.props.customer.data_scadenza_permesso_soggiorno.raw || '',
      }
    }

    if (t.props.customer.fatturazione_uguale === '0') {
      validation_map = {
        ...validation_map,
        dati_cliente_citta_fatturazione:
          t.props.customer.citta_fatturazione || '',
        dati_cliente_cap_fatturazione:
          t.state.cap_fatturazione || t.props.customer.cap_fatturazione || '',
        dati_cliente_indirizzo_fatturazione:
          t.props.customer.indirizzo_fatturazione || '',
        dati_cliente_numero_civico_fatturazione:
          t.props.customer.numero_civico_fatturazione || '',
        dati_cliente_ragione_sociale: t.props.customer.ragione_sociale || '',
      }
    }

    return validation_map
  }

  validation_map_residenza_e_domicilio() {
    const t = this
    let validation_map = {
      dati_compass_situazione_abitativa:
        t.props.compass.situazione_abitativa || '',
      dati_cliente_citta_residenza: t.props.customer.citta_residenza || '',
      dati_cliente_cap_residenza:
        t.state.cap_residenza || t.props.customer.cap_residenza || '',
      dati_cliente_indirizzo_residenza:
        t.props.customer.indirizzo_residenza || '',
      dati_cliente_numero_civico_residenza:
        t.props.customer.numero_civico_residenza || '',
      dati_compass_residente_dal: t.props.compass.residente_dal.raw || '',
      dati_cliente_domicilio_diverso: t.props.customer.domicilio_diverso || '0',
      dati_compass_membri_familiari: t.props.compass.membri_familiari || '',
      dati_compass_familiari_con_reddito:
        t.props.compass.familiari_con_reddito || '',
    }

    if (t.residenzaPrecendenteRequired()) {
      validation_map = {
        ...validation_map,
        dati_compass_comune_precedente: t.props.compass.comune_precedente || '',
        dati_compass_cap_precedente:
          t.state.cap_precedente || t.props.compass.cap_precedente || '',
        dati_compass_indirizzo_precedente:
          t.props.compass.indirizzo_precedente || '',
        dati_compass_civico_precedente: t.props.compass.civico_precedente || '',
      }
    }

    if (t.props.customer.domicilio_diverso === '1') {
      validation_map = {
        ...validation_map,
        dati_cliente_citta_domicilio: t.props.customer.citta_domicilio || '',
        dati_cliente_cap_domicilio:
          t.state.cap_domicilio || t.props.customer.cap_domicilio || '',
        dati_cliente_indirizzo_domicilio:
          t.props.customer.indirizzo_domicilio || '',
        dati_cliente_civico_domicilio: t.props.customer.civico_domicilio || '',
      }
    }

    return validation_map
  }

  validation_map_validate_lavoro() {
    const t = this
    let validation_map = {
      dati_compass_tipo_attivita: t.props.compass.tipo_attivita || '',
    }

    if (t.tipoAttivita(t.props.compass.tipo_attivita) === 'A') {
      validation_map = {
        ...validation_map,
        dati_compass_settore: t.props.compass.settore || '',
        dati_compass_occupazione: t.props.compass.occupazione || '',
        dati_compass_reddito: t.props.compass.reddito || '',
        dati_compass_data_inizio_attivita:
          t.props.compass.data_inizio_attivita.raw || '',
        dati_compass_datore_lavoro: t.props.compass.datore_lavoro || '',
        dati_compass_telefono_fisso_lavoro:
          t.props.compass.telefono_fisso_lavoro || '',
        dati_compass_comune_lavoro: t.props.compass.comune_lavoro || '',
        dati_compass_cap_lavoro:
          t.state.cap_lavoro || t.props.compass.cap_lavoro || '',
        dati_compass_indirizzo_lavoro: t.props.compass.indirizzo_lavoro || '',
        dati_compass_civico_lavoro: t.props.compass.civico_lavoro || '',
      }
    }

    if (t.tipoAttivita(t.props.compass.tipo_attivita) === 'DD') {
      validation_map = {
        ...validation_map,
        dati_compass_data_scadenza_contratto:
          t.props.compass.data_scadenza_contratto.raw || '',
        dati_compass_datore_lavoro: t.props.compass.datore_lavoro || '',
        dati_compass_telefono_fisso_lavoro:
          t.props.compass.telefono_fisso_lavoro || '',
        dati_compass_comune_lavoro: t.props.compass.comune_lavoro || '',
        dati_compass_cap_lavoro:
          t.state.cap_lavoro || t.props.compass.cap_lavoro || '',
        dati_compass_indirizzo_lavoro: t.props.compass.indirizzo_lavoro || '',
        dati_compass_civico_lavoro: t.props.compass.civico_lavoro || '',
      }
    }

    if (t.tipoAttivita(t.props.compass.tipo_attivita) === 'DI') {
      validation_map = {
        ...validation_map,
        dati_compass_datore_lavoro: t.props.compass.datore_lavoro || '',
        dati_compass_telefono_fisso_lavoro:
          t.props.compass.telefono_fisso_lavoro || '',
        dati_compass_comune_lavoro: t.props.compass.comune_lavoro || '',
        dati_compass_cap_lavoro:
          t.state.cap_lavoro || t.props.compass.cap_lavoro || '',
        dati_compass_indirizzo_lavoro: t.props.compass.indirizzo_lavoro || '',
        dati_compass_civico_lavoro: t.props.compass.civico_lavoro || '',
      }
    }

    return validation_map
  }

  validation_map_conto_corrente() {
    const t = this
    const validation_map = {
      dati_compass_tipo_conto_corrente:
        t.props.compass.tipo_conto_corrente || '',
      dati_compass_data_apertura_conto:
        t.props.compass.data_apertura_conto.raw || '',
      dati_compass_altre_carte: t.props.compass.altre_carte || [],
      dati_compass_iban: t.props.compass.iban || '',
    }

    return validation_map
  }

  validation_map_privacy() {
    const t = this
    const validation_map = {
      dati_compass_privacy_obbligatoria_1_mag2018:
        t.props.compass.privacy_obbligatoria_1_mag2018 || '',
      dati_compass_privacy_facoltativa_1:
        t.props.compass.privacy_facoltativa_1 || '',
      dati_compass_privacy_facoltativa_2:
        t.props.compass.privacy_facoltativa_2 || '',
      dati_compass_privacy_facoltativa_3:
        t.props.compass.privacy_facoltativa_3 || '',
      dati_compass_presa_visione_obbligatoria:
        t.props.compass.presa_visione_obbligatoria || '',
      dati_compass_condizioni_brumbrum_obbligatorie:
        t.props.compass.condizioni_brumbrum_obbligatorie || '',
    }

    if (haGaranzia3Anni(t.props.garanzia)) {
      validation_map.dati_cliente_informativa_trattamento_dati_personali_garanzia =
        t.props.customer.informativa_trattamento_dati_personali_garanzia || ''
    }

    return validation_map
  }

  handleNext(sezione) {
    const t = this
    return function () {
      let validation_map = {}

      validation_map = {
        ...t.validation_map_dati_personali(),
        ...t.validation_map_residenza_e_domicilio(),
        ...t.validation_map_validate_lavoro(),
        ...t.validation_map_conto_corrente(),
        ...t.validation_map_privacy(),
      }

      const validation_results = Object.keys(validation_map).map(
        key => t.validate(key, validation_map[key], null, true).is_valid
      )

      if (
        !t.props.fetching &&
        validation_results.length > 0 &&
        validation_results.indexOf(false) === -1
      ) {
        t.setState({ section: t.state.section + 1 })
        animateScroll.scrollToTop()
        t.props.storeDumpItForce()
        if (sezione === 'privacy') {
          t.handleSubmit()
        }
      }
    }
  }

  handlePrev() {
    this.setState({ section: this.state.section - 1 })
    animateScroll.scrollToTop()
  }

  tipoAttivita(categoria) {
    const mappatura = {
      pensionato: 'D',
      studente: 'C',
      casalinghi: 'C',
      disoccupato: 'C',
      dipendente_indeterminato: 'DI',
      dipendente_determinato: 'DD',
      autonomo: 'A',
    }

    return mappatura[categoria]
  }

  residenzaPrecendenteRequired() {
    if (!this.props.compass.residente_dal.year) {
      return false
    }

    const year_diff =
      (new Date() -
        new Date(
          this.props.compass.residente_dal.year,
          this.props.compass.residente_dal.month,
          this.props.compass.residente_dal.day
        )) /
      1000 /
      60 /
      60 /
      24 /
      365.25
    return year_diff < 3
  }

  render() {
    const { customer } = this.props
    const { compass } = this.props
    const domicilioDiversoClasses =
      // eslint-disable-next-line
      customer.domicilio_diverso == '1' ? 'wide' : 'wide hide'
    const domicilioDiversoThreeClasses =
      // eslint-disable-next-line
      customer.domicilio_diverso == '1' ? 'three-t' : 'three-t hide'
    const domicilioDiversoTwoClasses =
      // eslint-disable-next-line
      customer.domicilio_diverso == '1' ? 'two-t' : 'two-t hide'
    const residenzaPrecedenteClasses = this.residenzaPrecendenteRequired()
      ? 'wide form-title'
      : 'wide form-title hide'
    const residenzaPrecedenteThreeClasses = this.residenzaPrecendenteRequired()
      ? 'three-t form-title'
      : 'three-t form-title hide'
    const residenzaPrecedenteTwoClasses = this.residenzaPrecendenteRequired()
      ? 'two-t form-title'
      : 'two-t form-title hide'

    return (
      <form className="form-passaggio">
        <BuyDataForm active icon="user" name="section-1" title="Dati Personali">
          <li className={`${this.state.dati_cliente_email_error} wide`}>
            <BuyTextInput
              classes={'input-data form-input big'}
              defaultValue={customer.email}
              label={'Email'}
              placeholder={'es: mario.rossi@gmail.com'}
              type={'email'}
              update={this.handleInput('email')}
              verify={customer.email !== ''}
            />
          </li>
          <li className={`${this.state.dati_cliente_phone_error} wide`}>
            <PhoneInput
              className="input-data"
              onChange={this.handleInput('phone')}
              placeholder={'Scrivi il tuo Numero di cellulare'}
              value={customer.phone}
            />
          </li>
          <li
            className={`${this.state.dati_compass_telefono_fisso_personale_error} wide`}
          >
            <PhoneInput
              className="input-data form-input big"
              label={'Telefono fisso personale (facoltativo)'}
              name={'telefono_fisso_personale'}
              onChange={this.handleInput(
                'telefono_fisso_personale',
                this.props.compassUpdate
              )}
              placeholder={'Scrivi il tuo Numero di telefono'}
              value={compass.telefono_fisso_personale}
            />
          </li>
          <li className="hr" />
          <li className="wide form-title you-pep">
            <label>
              <a
                href={`${window.brumbrum.files_domain}/definizione-di-persona-politicamente-esposta.pdf`}
                rel="noreferrer"
                target="_blank"
              >
                Sei una persona politicamente esposta?
              </a>
            </label>
          </li>
          <BuyRadioInput
            defaultValue={this.props.compass.politicamente_esposto || '0'}
            label={'persona_politicamente_esposta '}
            liClassName={`${this.state.dati_compass_politicamente_esposto_error} wide you-pep`}
            update={this.handleRadio(
              'politicamente_esposto',
              this.props.compassUpdate
            )}
            values={[
              { label: 'No', value: '0' },
              { label: 'Si', value: '1' },
            ]}
          />
          {/* eslint-disable-next-line */}
          {this.props.compass.politicamente_esposto == '1' ? (
            <li className="wide">
              <small>
                <a
                  className="modal-btn"
                  data-modal="modulo-pep"
                  href="/assets/pdf/modulo-pep.pdf"
                  style={{ marginTop: '10px' }}
                  target="_blank"
                >
                  <i
                    className="icon-upload"
                    style={{
                      fontSize: '17px',
                      position: 'relative',
                      top: '3px',
                    }}
                  ></i>
                  Scarica e compila questo modulo.
                </a>
              </small>
            </li>
          ) : null}
          <li className="hr" />
          <BuySelectInput2
            defaultValue={this.props.compass.stato_civile}
            label={'Stato civile'}
            liClassName={`${this.state.dati_compass_stato_civile_error} wide you-pep`}
            placeholder={'Seleziona lo Stato civile'}
            update={this.handleSelect('stato_civile', this.props.compassUpdate)}
            values={[
              { label: 'Single (Celibe / Nubile)', value: 'Celibe/Nubile' },
              { label: 'Convivente', value: 'Convivente' },
              {
                label: 'Sposato in comunione dei beni',
                value: 'Sposato_Comunione',
              },
              {
                label: 'Sposato in separazione dei beni',
                value: 'Sposato_Separazione',
              },
              { label: 'Separato', value: 'Separato' },
              { label: 'Divorziato', value: 'Divorziato' },
              { label: 'Vedovo', value: 'Vedovo' },
            ]}
          />
          <li className="hr" />
          <li className={`${this.state.dati_cliente_partita_iva_error} wide`}>
            <BuyTextInput
              classes="form-input big uppercase"
              defaultValue={customer.partita_iva}
              label={'Partita IVA (facoltativo)'}
              placeholder={'Scrivi la Partita IVA'}
              type={'text'}
              update={this.handleInput('partita_iva')}
            />
          </li>

          <li className="hr" />

          <li className="wide form-title">
            <label>Documento di riconoscimento</label>
          </li>

          <BuyRadioInput
            defaultValue={customer.documento}
            label={'documento '}
            liClassName={`${this.state.dati_cliente_documento_error} wide you-pep`}
            spanClass="value small"
            update={this.handleRadio('documento')}
            values={[
              { label: "Carta d'identità", value: 'CI' },
              { label: 'Passaporto', value: 'Passaporto' },
              { label: 'Patente', value: 'Patente' },
            ]}
          />
          {this.state.documento.length > 0 && (
            <li
              className={`${this.state.dati_cliente_numero_documento_error} wide`}
            >
              <BuyTextInput
                classes="input-data form-input big uppercase"
                defaultValue={customer.numero_documento}
                label={'Numero del documento'}
                placeholder={'Scrivi il Numero del documento'}
                type={'text'}
                update={this.handleInput('numero_documento')}
              />
            </li>
          )}
          {this.state.documento.length > 0 && (
            <BuySelectInput2
              defaultValue={customer.ente_rilascio_documento}
              disabled={this.state.documento.length === 0}
              label={
                this.state.documento === 'CI'
                  ? 'Rilasciato dal Comune di'
                  : this.state.documento === 'Passaporto'
                  ? 'Rilasciato dal Min. Affari Esteri/Questura di'
                  : this.state.documento === 'Patente'
                  ? 'Rilasciato dalla Prefettura/Mot. Civile di'
                  : 'Rilasciato da'
              }
              liClassName={`${this.state.dati_cliente_ente_rilascio_documento_error} wide`}
              placeholder={'Seleziona il Tipo di documento'}
              update={this.handleSelect('ente_rilascio_documento')}
              values={
                this.state.documento === 'Passaporto'
                  ? this.props.comuni.comune.concat(this.props.comuni.nazione)
                  : this.props.comuni.comune
              }
            />
          )}
          {this.state.documento.length > 0 && (
            <li
              className={`${this.state.dati_cliente_data_rilascio_documento_error} wide`}
            >
              <BuyDateInput
                classes="form-input big"
                defaultValue={
                  this.props.customer.data_rilascio_documento.raw || ''
                }
                label={'Data di rilascio (gg/mm/aaaa)'}
                placeholder={'00/00/0000'}
                type={'text'}
                update={this.handleInput('data_rilascio_documento')}
              />
            </li>
          )}
          <BuySelectInput2
            defaultValue={customer.cittadinanza}
            label={'Cittadinanza'}
            liClassName={`${this.state.dati_cliente_cittadinanza_error} wide`}
            placeholder={'Seleziona la Cittadinanza'}
            update={this.handleSelect('cittadinanza')}
            values={this.props.compass_tabelledominio.cittadinanza}
          />
          {this.props.compass_tabelledominio.cittadinanza_is_extra_eu_by_codice[
            this.props.customer.cittadinanza
              ? this.props.customer.cittadinanza.split('|')[0]
              : ''
          ] && <li className="hr" />}
          {this.props.compass_tabelledominio.cittadinanza_is_extra_eu_by_codice[
            this.props.customer.cittadinanza
              ? this.props.customer.cittadinanza.split('|')[0]
              : ''
          ] && (
            <li className={'wide'}>
              <label>Permesso di soggiorno</label>
            </li>
          )}
          {this.props.compass_tabelledominio.cittadinanza_is_extra_eu_by_codice[
            this.props.customer.cittadinanza
              ? this.props.customer.cittadinanza.split('|')[0]
              : ''
          ] && (
            <li
              className={`${this.state.dati_cliente_data_rilascio_permesso_soggiorno_error} wide`}
            >
              <BuyDateInput
                classes="form-input big"
                defaultValue={
                  this.props.customer.data_rilascio_permesso_soggiorno.raw || ''
                }
                label={'Soggiorno dal (mm/aaaa)'}
                mask="99/9999"
                placeholder={'00/0000'}
                type={'text'}
                update={this.handleInput('data_rilascio_permesso_soggiorno')}
              />
            </li>
          )}
          {this.props.compass_tabelledominio.cittadinanza_is_extra_eu_by_codice[
            this.props.customer.cittadinanza
              ? this.props.customer.cittadinanza.split('|')[0]
              : ''
          ] && (
            <li
              className={`${this.state.dati_cliente_data_scadenza_permesso_soggiorno_error} wide`}
            >
              <BuyDateInput
                classes="form-input big"
                defaultValue={
                  this.props.customer.data_scadenza_permesso_soggiorno.raw || ''
                }
                label={'Data di scadenza permesso (gg/mm/aaaa)'}
                placeholder={'00/00/0000'}
                type={'text'}
                update={this.handleInput('data_scadenza_permesso_soggiorno')}
              />
            </li>
          )}
          <li className="hr" />
          <li className="wide buttons">
            <a
              className="btn btn-primary js-next-step"
              onClick={this.handleNext('dati_personali')}
            >
              <span>Prosegui</span>
            </a>
          </li>
        </BuyDataForm>
        <BuyDataForm
          active
          icon="home"
          name="section-2"
          title="Residenza e domicilio"
        >
          <BuySelectInput2
            defaultValue={this.props.compass.situazione_abitativa}
            label={'Situazione abitativa'}
            liClassName={`${this.state.dati_compass_situazione_abitativa_error} wide`}
            placeholder={'Seleziona la Situazione abitativa'}
            update={this.handleSelect(
              'situazione_abitativa',
              this.props.compassUpdate
            )}
            values={[
              { label: 'Affitto', value: 'AFF' },
              { label: 'Proprieta', value: 'PRO' },
              { label: 'Proprieta con mutuo', value: 'PRM' },
              { label: 'Presso parenti', value: 'PAR' },
              { label: 'Presso terzi', value: 'TER' },
            ]}
          />
          <li className="hr" />
          <BuySelectInput2
            defaultValue={customer.citta_residenza}
            label={'Comune di residenza'}
            liClassName={`${this.state.dati_cliente_citta_residenza_error} two-t`}
            placeholder={'Seleziona il Comune'}
            update={this.handleSelect('citta_residenza')}
            values={this.props.comuni.comune}
          />
          {this.state.select_cap_residenza && (
            <BuySelectInput2
              clearable={false}
              defaultValue={this.state.cap_residenza}
              label={'Cap'}
              liClassName={`${this.state.dati_cliente_cap_residenza_error} three-t`}
              placeholder={'Cap'}
              update={this.handleSelect('cap_residenza')}
              values={this.state.caps_residenza}
            />
          )}
          {!this.state.select_cap_residenza && (
            <li
              className={`${this.state.dati_cliente_cap_residenza_error} three-t`}
            >
              <BuyTextInput2
                classes="input-data form-input big"
                disabled
                label={'Cap'}
                placeholder={'Scrivi il Cap'}
                type={'number'}
                update={this.handleInput('cap_residenza')}
                value={this.state.cap_residenza}
              />
            </li>
          )}
          <li
            className={`${this.state.dati_cliente_indirizzo_residenza_error} two-t`}
          >
            <BuyTextInput
              classes="input-data form-input big capitalize"
              defaultValue={customer.indirizzo_residenza}
              label={'Indirizzo di residenza'}
              placeholder={"Scrivi l'indirizzo"}
              type={'text'}
              update={this.handleInput('indirizzo_residenza')}
            />
          </li>
          <li
            className={`${this.state.dati_cliente_numero_civico_residenza_error} three-t`}
          >
            <BuyTextInput
              classes="input-data form-input big"
              defaultValue={customer.numero_civico_residenza}
              label={'Civico'}
              placeholder={'Civico'}
              type={'text'}
              update={this.handleInput('numero_civico_residenza')}
            />
          </li>
          <li className="hr" />
          <li className={`${this.state.dati_compass_residente_dal_error} wide`}>
            <BuyDateInput
              classes="form-input big"
              defaultValue={this.props.compass.residente_dal.raw || ''}
              label={'Residente dal (mm/aaaa)'}
              mask="99/9999"
              placeholder={'00/0000'}
              type={'text'}
              update={this.handleInput(
                'residente_dal',
                this.props.compassUpdate
              )}
            />
            <div className="guide-tips">
              <span className="guide-tips-label">
                In caso di dubbi, consulta l'aiuto!
              </span>
            </div>
          </li>

          <li className={residenzaPrecedenteClasses}>
            <label>Residenza precedente</label>
          </li>
          <BuySelectInput2
            defaultValue={compass.comune_precedente}
            label={'Comune precedente'}
            liClassName={residenzaPrecedenteTwoClasses.concat(
              this.state.dati_compass_comune_precedente_error
            )}
            placeholder={'Seleziona il Comune'}
            update={this.handleSelect(
              'comune_precedente',
              this.props.compassUpdate
            )}
            values={this.props.comuni.comune}
          />
          {this.state.select_cap_precedente && (
            <BuySelectInput2
              clearable={false}
              defaultValue={this.state.cap_precedente}
              label={'Cap'}
              liClassName={residenzaPrecedenteThreeClasses.concat(
                this.state.dati_compass_cap_precedente_error
              )}
              placeholder={'Cap'}
              update={this.handleSelect(
                'cap_precedente',
                this.props.compassUpdate
              )}
              values={this.state.caps_precedente}
            />
          )}
          {!this.state.select_cap_precedente && (
            <li
              className={residenzaPrecedenteThreeClasses.concat(
                this.state.dati_compass_cap_precedente_error
              )}
            >
              <BuyTextInput2
                classes="input-data form-input big"
                disabled
                label={'Cap'}
                placeholder={'Scrivi il Cap'}
                type={'number'}
                update={this.handleInput(
                  'cap_precedente',
                  this.props.compassUpdate
                )}
                value={this.state.cap_precedente}
              />
            </li>
          )}
          <li
            className={residenzaPrecedenteTwoClasses.concat(
              this.state.dati_compass_indirizzo_precedente_error
            )}
          >
            <BuyTextInput
              classes="input-data form-input big capitalize"
              defaultValue={compass.indirizzo_precedente}
              label={'Indirizzo precedente'}
              placeholder={"Scrivi l'indirizzo"}
              type={'text'}
              update={this.handleInput(
                'indirizzo_precedente',
                this.props.compassUpdate
              )}
            />
          </li>
          <li
            className={residenzaPrecedenteThreeClasses.concat(
              this.state.dati_compass_civico_precedente_error
            )}
          >
            <BuyTextInput
              classes="input-data form-input big"
              defaultValue={compass.civico_precedente}
              label={'Civico'}
              placeholder={'Civico'}
              type={'text'}
              update={this.handleInput(
                'civico_precedente',
                this.props.compassUpdate
              )}
            />
          </li>

          <li className="hr" />

          <li className="wide form-title">
            <label>I dati di fatturazione sono uguali alla residenza?</label>
          </li>
          <BuyRadioInput
            defaultValue={
              customer.fatturazione_uguale
                ? `${customer.fatturazione_uguale}`
                : '1'
            }
            label={'fatturazione_uguale'}
            liClassName={`${this.state.dati_cliente_fatturazione_uguale_error} wide`}
            update={this.handleRadio('fatturazione_uguale')}
            values={[
              { label: 'No', value: '0' },
              { label: 'Si', value: '1' },
            ]}
          />

          {customer.fatturazione_uguale === '0' ? (
            <li
              className={`${this.state.dati_cliente_ragione_sociale_error} wide`}
            >
              <BuyTextInput
                classes="form-input big uppercase"
                defaultValue={customer.ragione_sociale}
                label={'Ragione sociale (facoltativa)'}
                placeholder={'Scrivi la Ragione sociale'}
                type={'text'}
                update={this.handleInput('ragione_sociale')}
              />
            </li>
          ) : null}

          {customer.fatturazione_uguale === '0' ? (
            <BuySelectInput2
              async
              defaultValue={customer.citta_fatturazione}
              label="Comune di fatturazione"
              liClassName={`${this.state.dati_cliente_citta_fatturazione_error} two-t`}
              loadOptions={searchQuery => {
                const c = customer.citta_fatturazione
                  ? customer.citta_fatturazione.split('|')[0]
                  : ''
                const sq = searchQuery || c
                return this.props
                  .searchComuniV2Residenza(sq)
                  .then(json => transformComuniResidenzaV2Result(json.result))
              }}
              placeholder={'Seleziona il Comune'}
              update={this.handleSelect('citta_fatturazione')}
              values={this.props.comuni.comune}
            />
          ) : null}

          {customer.fatturazione_uguale === '0' &&
          this.state.select_cap_fatturazione ? (
            <BuySelectInput2
              clearable={false}
              defaultValue={this.state.cap_fatturazione}
              label={'Cap'}
              liClassName={`${this.state.dati_cliente_cap_fatturazione_error} three-t`}
              placeholder={'Cap'}
              update={this.handleSelect('cap_fatturazione')}
              values={this.state.caps_fatturazione}
            />
          ) : null}

          {customer.fatturazione_uguale === '0' &&
          !this.state.select_cap_fatturazione ? (
            <li
              className={`${this.state.dati_cliente_cap_fatturazione_error} three-t`}
            >
              <BuyTextInput2
                classes="input-data form-input big"
                disabled
                label={'Cap'}
                placeholder={'Scrivi il Cap'}
                type={'text'}
                update={this.handleInput('cap_fatturazione')}
                value={this.state.cap_fatturazione}
              />
            </li>
          ) : null}

          {customer.fatturazione_uguale === '0' ? (
            <li
              className={`${this.state.dati_cliente_indirizzo_fatturazione_error} two-t`}
            >
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={customer.indirizzo_fatturazione}
                label={'Indirizzo di fatturazione'}
                placeholder={"Scrivi l'indirizzo"}
                type={'text'}
                update={this.handleInput('indirizzo_fatturazione')}
              />
            </li>
          ) : null}

          {customer.fatturazione_uguale === '0' ? (
            <li
              className={`${this.state.dati_cliente_numero_civico_fatturazione_error} three-t`}
            >
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={customer.numero_civico_fatturazione}
                label={'Civico'}
                placeholder={'Civico'}
                type={'text'}
                update={this.handleInput('numero_civico_fatturazione')}
              />
            </li>
          ) : null}

          <li className="hr" />
          <li className="wide form-title">
            <label>Il domicilio è diverso dall’indirizzo di residenza?</label>
          </li>
          <BuyRadioInput
            defaultValue={customer.domicilio_diverso || '0'}
            label={'domicilio_diverso'}
            liClassName={`${this.state.dati_cliente_domicilio_diverso_error} wide`}
            update={this.handleRadio('domicilio_diverso')}
            values={[
              { label: 'No', value: '0' },
              { label: 'Si', value: '1' },
            ]}
          />

          <li className={`${domicilioDiversoClasses} hr`} />
          <BuySelectInput2
            async
            defaultValue={customer.citta_domicilio}
            label="Comune di domicilio"
            liClassName={`${domicilioDiversoTwoClasses.concat(
              this.state.dati_cliente_citta_domicilio_error
            )} two-t`}
            loadOptions={searchQuery => {
              const c = customer.citta_domicilio
                ? customer.citta_domicilio.split('|')[0]
                : ''
              const sq = searchQuery || c
              return this.props
                .searchComuniV2Residenza(sq)
                .then(json => transformComuniResidenzaV2Result(json.result))
            }}
            placeholder={'Seleziona il Comune'}
            update={this.handleSelect('citta_domicilio')}
            values={this.props.comuni.comune}
          />
          {this.state.select_cap_domicilio && (
            <BuySelectInput2
              clearable={false}
              defaultValue={this.state.cap_domicilio}
              label={'Cap'}
              liClassName={domicilioDiversoThreeClasses.concat(
                this.state.dati_cliente_cap_domicilio_error
              )}
              placeholder={'Cap'}
              update={this.handleSelect('cap_domicilio')}
              values={this.state.caps_domicilio}
            />
          )}
          {!this.state.select_cap_domicilio && (
            <li
              className={domicilioDiversoThreeClasses.concat(
                this.state.dati_cliente_cap_domicilio_error
              )}
            >
              <BuyTextInput2
                classes="input-data form-input big"
                disabled
                label={'Cap'}
                placeholder={'Scrivi il Cap'}
                type={'number'}
                update={this.handleInput('cap_domicilio')}
                value={this.state.cap_domicilio}
              />
            </li>
          )}
          <li
            className={domicilioDiversoTwoClasses.concat(
              this.state.dati_cliente_indirizzo_domicilio_error
            )}
          >
            <BuyTextInput
              classes="input-data form-input big capitalize"
              defaultValue={customer.indirizzo_domicilio}
              label={'Indirizzo di domicilio'}
              placeholder={"Scrivi l'indirizzo"}
              type={'text'}
              update={this.handleInput('indirizzo_domicilio')}
            />
          </li>
          <li
            className={domicilioDiversoThreeClasses.concat(
              this.state.dati_cliente_civico_domicilio_error
            )}
          >
            <BuyTextInput
              classes="input-data form-input big"
              defaultValue={customer.civico_domicilio}
              label={'Civico'}
              placeholder={'Civico'}
              type={'text'}
              update={this.handleInput('civico_domicilio')}
            />
          </li>
          <li className="hr" />

          <li className="wide form-title">
            <label>Membri del nucleo familiare</label>
          </li>
          <BuyRadioInput
            defaultValue={compass.membri_familiari}
            label={'membri_familiari'}
            liClassName={`${this.state.dati_compass_membri_familiari_error} wide`}
            update={this.handleRadio(
              'membri_familiari',
              this.props.compassUpdate
            )}
            values={[
              { label: '1', value: '1' },
              { label: '2', value: '2' },
              { label: '3', value: '3' },
              { label: '3+', value: '3+' },
            ]}
          />
          <li className="wide">
            <div className="guide-tips no-mrg">
              <span className="guide-tips-label">
                In caso di dubbi, consulta l'aiuto!
              </span>
            </div>
          </li>
          <li className="wide form-title">
            <label>Familiari con reddito</label>
          </li>
          <BuyRadioInput
            defaultValue={compass.familiari_con_reddito}
            label={'familiari_con_reddito'}
            liClassName={`${this.state.dati_compass_familiari_con_reddito_error} wide`}
            update={this.handleRadio(
              'familiari_con_reddito',
              this.props.compassUpdate
            )}
            values={[
              { label: '1', value: '1' },
              { label: '2', value: '2' },
              { label: '3', value: '3' },
              { label: '3+', value: '3+' },
            ]}
          />
          <li className="wide buttons">
            <a
              className="btn btn-primary js-next-step"
              onClick={this.handleNext('residenza_e_domicilio')}
            >
              <span>Prosegui</span>
            </a>
            <a
              className="btn btn-back js-back-step mt-30"
              onClick={this.handlePrev}
            >
              Indietro
            </a>
          </li>
        </BuyDataForm>
        <BuyDataForm
          active={this.state.section === 3}
          icon="work"
          name="section-3"
          title="Lavoro"
        >
          <BuySelectInput2
            defaultValue={this.props.compass.tipo_attivita}
            label={'Tipo di attività'}
            liClassName={`${this.state.dati_compass_tipo_attivita_error} wide`}
            placeholder={'Seleziona il Tipo di attività'}
            update={this.handleSelect(
              'tipo_attivita',
              this.props.compassUpdate
            )}
            values={[
              { label: 'Autonomo/libero professionista', value: 'autonomo' },
              {
                label: 'Dipendente a tempo indeterminato',
                value: 'dipendente_indeterminato',
              },
              {
                label: 'Dipendente a tempo determinato',
                value: 'dipendente_determinato',
              },
              { label: 'Pensionato/a', value: 'pensionato' },
              { label: 'Studente', value: 'studente' },
              { label: 'Casalingo/a', value: 'casalinghi' },
              {
                label: 'Senza occupazione o senza reddito',
                value: 'disoccupato',
              },
            ]}
          />

          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            this.tipoAttivita(compass.tipo_attivita) === 'A' && (
              <BuySelectInput2
                defaultValue={this.props.compass.settore}
                label={'Settore'}
                liClassName={`${this.state.dati_compass_settore_error} wide`}
                placeholder={'Seleziona il Settore'}
                update={this.handleSelect('settore', this.props.compassUpdate)}
                values={this.props.compass_tabelledominio.settoreattivita}
              />
            )}

          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            this.tipoAttivita(compass.tipo_attivita) === 'A' && (
              <BuySelectInput2
                defaultValue={this.props.compass.occupazione}
                label={'Occupazione'}
                liClassName={`${this.state.dati_compass_occupazione_error} wide`}
                placeholder={"Seleziona l'Occupazione"}
                update={this.handleSelect(
                  'occupazione',
                  this.props.compassUpdate
                )}
                values={
                  this.props.compass_tabelledominio.occupazioneattivita[
                    compass.settore
                  ]
                }
              />
            )}

          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            this.tipoAttivita(compass.tipo_attivita) === 'A' && (
              <li
                className={`${this.state.dati_compass_data_inizio_attivita_error} wide`}
              >
                <BuyDateInput
                  classes="form-input big"
                  defaultValue={
                    this.props.compass.data_inizio_attivita.raw || ''
                  }
                  label={'Data inizio attivita (mm/aaaa)'}
                  mask="99/9999"
                  placeholder={'00/0000'}
                  type={'text'}
                  update={this.handleInput(
                    'data_inizio_attivita',
                    this.props.compassUpdate
                  )}
                />
              </li>
            )}

          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            this.tipoAttivita(compass.tipo_attivita) === 'A' && (
              <li className={`${this.state.dati_compass_reddito_error} wide`}>
                <BuyTextInput
                  classes="input-data form-input big"
                  defaultValue={compass.reddito}
                  isSymbol="input-symbol"
                  label={'Reddito annuo lordo'}
                  placeholder={'Scrivi il Reddito annuo lordo'}
                  theSymbol="€"
                  type={'text'}
                  update={this.handleInput('reddito', this.props.compassUpdate)}
                />
              </li>
            )}

          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            this.tipoAttivita(compass.tipo_attivita) === 'A' && (
              <li className="hr" />
            )}
          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            this.tipoAttivita(compass.tipo_attivita) === 'DD' && (
              <li
                className={`${this.state.dati_compass_data_scadenza_contratto_error} wide`}
              >
                <BuyDateInput
                  classes="form-input big"
                  defaultValue={
                    this.props.compass.data_scadenza_contratto.raw || ''
                  }
                  label={'Data scadenza contratto (gg/mm/aaaa)'}
                  placeholder={'00/00/0000'}
                  type={'text'}
                  update={this.handleInput(
                    'data_scadenza_contratto',
                    this.props.compassUpdate
                  )}
                />
              </li>
            )}
          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            (this.tipoAttivita(compass.tipo_attivita) === 'A' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DI' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DD') && (
              <li className="wide form-title ">
                <label>Sede di lavoro</label>
              </li>
            )}
          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            (this.tipoAttivita(compass.tipo_attivita) === 'A' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DI' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DD') && (
              <li
                className={`${this.state.dati_compass_datore_lavoro_error} wide`}
              >
                <BuyTextInput
                  classes="input-data form-input big capitalize"
                  defaultValue={compass.datore_lavoro}
                  label={
                    this.tipoAttivita(compass.tipo_attivita) === 'A'
                      ? 'Denominazione società'
                      : 'Datore di lavoro'
                  }
                  placeholder={
                    this.tipoAttivita(compass.tipo_attivita) === 'A'
                      ? 'Scrivi la Denominazione società'
                      : 'Scrivi il Datore di lavoro'
                  }
                  type={'text'}
                  update={this.handleInput(
                    'datore_lavoro',
                    this.props.compassUpdate
                  )}
                />
              </li>
            )}
          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            (this.tipoAttivita(compass.tipo_attivita) === 'A' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DI' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DD') && (
              <li
                className={`${this.state.dati_compass_telefono_fisso_lavoro_error} wide`}
              >
                <PhoneInput
                  className="input-data form-input big"
                  label={'Telefono fisso lavoro (facoltativo)'}
                  name={'telefono_fisso_lavoro'}
                  onChange={this.handleInput(
                    'telefono_fisso_lavoro',
                    this.props.compassUpdate
                  )}
                  placeholder={'Scrivi il tuo Numero di telefono'}
                  value={compass.telefono_fisso_lavoro}
                />
              </li>
            )}
          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            (this.tipoAttivita(compass.tipo_attivita) === 'A' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DI' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DD') && (
              <BuySelectInput2
                defaultValue={compass.comune_lavoro}
                label={'Comune di lavoro'}
                liClassName={`${this.state.dati_compass_comune_lavoro_error} two-t`}
                placeholder={'Seleziona il Comune'}
                update={this.handleSelect(
                  'comune_lavoro',
                  this.props.compassUpdate
                )}
                values={this.props.comuni.comune}
              />
            )}
          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            (this.tipoAttivita(compass.tipo_attivita) === 'A' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DI' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DD') &&
            this.state.select_cap_lavoro && (
              <BuySelectInput2
                clearable={false}
                defaultValue={this.state.cap_lavoro}
                label={'Cap'}
                liClassName={`${this.state.dati_compass_cap_lavoro_error} three-t`}
                placeholder={'CAP'}
                update={this.handleSelect(
                  'cap_lavoro',
                  this.props.compassUpdate
                )}
                values={this.state.caps_lavoro}
              />
            )}
          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            (this.tipoAttivita(compass.tipo_attivita) === 'A' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DI' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DD') &&
            !this.state.select_cap_lavoro && (
              <li
                className={`${this.state.dati_compass_cap_lavoro_error} three-t`}
              >
                <BuyTextInput2
                  classes="input-data form-input big"
                  disabled
                  label={'Cap'}
                  placeholder={'Scrivi il Cap'}
                  type={'number'}
                  update={this.handleInput(
                    'cap_lavoro',
                    this.props.compassUpdate
                  )}
                  value={this.state.cap_lavoro}
                />
              </li>
            )}
          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            (this.tipoAttivita(compass.tipo_attivita) === 'A' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DI' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DD') && (
              <li
                className={`${this.state.dati_compass_indirizzo_lavoro_error} two-t`}
              >
                <BuyTextInput
                  classes="input-data form-input big capitalize"
                  defaultValue={compass.indirizzo_lavoro}
                  label={'Indirizzo di lavoro'}
                  placeholder={"Scrivi l'indirizzo"}
                  type={'text'}
                  update={this.handleInput(
                    'indirizzo_lavoro',
                    this.props.compassUpdate
                  )}
                />
              </li>
            )}
          {this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
            (this.tipoAttivita(compass.tipo_attivita) === 'A' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DI' ||
              this.tipoAttivita(compass.tipo_attivita) === 'DD') && (
              <li
                className={`${this.state.dati_compass_civico_lavoro_error} three-t`}
              >
                <BuyTextInput
                  classes="input-data form-input big"
                  defaultValue={compass.civico_lavoro}
                  label={'Civico'}
                  placeholder={'Civico'}
                  type={'text'}
                  update={this.handleInput(
                    'civico_lavoro',
                    this.props.compassUpdate
                  )}
                />
              </li>
            )}

          <li className="wide buttons">
            {compass.tipo_attivita &&
              this.tipoAttivita(compass.tipo_attivita) !== 'C' &&
              (this.tipoAttivita(compass.tipo_attivita) !== 'DD' ||
                (this.tipoAttivita(compass.tipo_attivita) === 'DD' &&
                  this.state.dati_compass_data_scadenza_contratto_error
                    .length === 0)) && (
                <a
                  className="btn btn-primary js-next-step"
                  disabled={
                    this.tipoAttivita(compass.tipo_attivita) !== 'A' ||
                    this.tipoAttivita(compass.tipo_attivita) !== 'DD' ||
                    this.tipoAttivita(compass.tipo_attivita) !== 'DI' ||
                    this.state.dati_compass_data_scadenza_contratto_error
                      .length > 0
                  }
                  onClick={this.handleNext('lavoro')}
                >
                  <span>Prosegui</span>
                </a>
              )}
            {!compass.tipo_attivita ||
              (this.tipoAttivita(compass.tipo_attivita) === 'C' && (
                <div>
                  <p className="static__section__description">
                    A causa del tipo attività selezionato siamo spiacenti di
                    comunicarti che il nostro partner Compass Banca non può
                    accogliere la richiesta di finanziamento. Per valutare
                    soluzioni alternative chiama il nostro Servizio Clienti al
                    numero{' '}
                    <a href={`tel:${this.props.ui.setting.phoneNumber}`}>
                      02.800.29
                    </a>
                    !
                  </p>
                </div>
              ))}
            {this.tipoAttivita(compass.tipo_attivita) === 'DD' &&
              this.state.dati_compass_data_scadenza_contratto_error.length >
                0 && (
                <div>
                  <p className="static__section__description">
                    A causa della scadenza del contratto indicata, antecedente
                    la fine prevista per il finanziamento, siamo spiacenti di
                    comunicarti che il nostro partner Compass Banca non può
                    accogliere la richiesta di finanziamento. Per valutare
                    soluzioni alternative chiama il nostro Servizio Clienti al
                    numero{' '}
                    <a href={`tel:${this.props.ui.settings.phoneNumber}`}>
                      02.800.29
                    </a>
                    !
                  </p>
                </div>
              )}
            <a
              className="btn btn-back js-back-step mt-30"
              onClick={this.handlePrev}
            >
              Indietro
            </a>
          </li>
        </BuyDataForm>
        <BuyDataForm
          active={this.state.section === 4}
          icon="bank"
          name="section-4"
          title="Conto corrente"
        >
          <BuySelectInput2
            defaultValue={compass.tipo_conto_corrente}
            label={'Tipo di conto corrente'}
            liClassName={`${this.state.dati_compass_tipo_conto_corrente_error} wide`}
            placeholder={'Seleziona il Tipo di conto'}
            update={this.handleSelect(
              'tipo_conto_corrente',
              this.props.compassUpdate
            )}
            values={[
              { label: 'Conto corrente bancario', value: 'CCB' },
              { label: 'Conto corrente postale', value: 'CCP' },
            ]}
          />

          {this.props.compass.tipo_conto_corrente !== 'NES' && (
            <li
              className={`${this.state.dati_compass_data_apertura_conto_error} wide`}
            >
              <BuyDateInput
                classes="form-input big"
                defaultValue={this.props.compass.data_apertura_conto.raw || ''}
                label={'Data di apertura del conto (mm/aaaa)'}
                mask="99/9999"
                placeholder={'00/0000'}
                type={'text'}
                update={this.handleInput(
                  'data_apertura_conto',
                  this.props.compassUpdate
                )}
              />
              <div className="guide-tips">
                <span className="guide-tips-label">
                  In caso di dubbio, consulta l'aiuto!
                </span>
              </div>
            </li>
          )}

          {this.props.compass.tipo_conto_corrente !== 'NES' && (
            <li className="hr" />
          )}

          {this.props.compass.tipo_conto_corrente !== 'NES' && (
            <li className="wide form-title">
              <label>Possiedi carte di credito?</label>
            </li>
          )}

          {this.props.compass.tipo_conto_corrente !== 'NES' && (
            <li className={`${this.state.dati_compass_altre_carte_error} wide`}>
              <BuyCheckboxInput2
                classes="radio-buttons big six input-1"
                defaultChecked={!!compass.altre_carte.find(v => v === 'N')}
                labelInside={'Nessuna carta'}
                spanClasses="value small"
                update={this.handleCheckbox(
                  'altre_carte',
                  this.props.compassUpdate
                )}
                value="N"
              />
              <BuyCheckboxInput2
                classes="radio-buttons big six input-2"
                defaultChecked={!!compass.altre_carte.find(v => v === 'A')}
                labelInside={'American Express'}
                spanClasses="value small"
                update={this.handleCheckbox(
                  'altre_carte',
                  this.props.compassUpdate
                )}
                value="A"
              />
              <BuyCheckboxInput2
                classes="radio-buttons big six input-3"
                defaultChecked={!!compass.altre_carte.find(v => v === 'V')}
                labelInside={'Visa'}
                spanClasses="value small"
                update={this.handleCheckbox(
                  'altre_carte',
                  this.props.compassUpdate
                )}
                value="V"
              />
              <BuyCheckboxInput2
                classes="radio-buttons big six input-4"
                defaultChecked={!!compass.altre_carte.find(v => v === 'C')}
                labelInside={'Mastercard'}
                spanClasses="value small"
                update={this.handleCheckbox(
                  'altre_carte',
                  this.props.compassUpdate
                )}
                value="C"
              />
              <BuyCheckboxInput2
                classes="radio-buttons big six input-5"
                defaultChecked={!!compass.altre_carte.find(v => v === 'X')}
                labelInside={'Bancomat'}
                spanClasses="value small"
                update={this.handleCheckbox(
                  'altre_carte',
                  this.props.compassUpdate
                )}
                value="X"
              />
              <BuyCheckboxInput2
                classes="radio-buttons big six input-6"
                defaultChecked={!!compass.altre_carte.find(v => v === 'Z')}
                labelInside={'Altra carta'}
                spanClasses="value small"
                update={this.handleCheckbox(
                  'altre_carte',
                  this.props.compassUpdate
                )}
                value="Z"
              />
            </li>
          )}

          {this.props.compass.tipo_conto_corrente !== 'NES' && (
            <li
              className={`${this.state.dati_compass_iban_error} wide background`}
            >
              <h4>Addebito rate del finanziamento</h4>
              <p>
                Ti chiediamo di inserire l’IBAN sul quale desideri vengano
                addebitate le rate del finanziamento che stai richiedendo.
                <br />È necessario che l’IBAN indicato sia intestato/cointestato
                al richiedente del finanziamento.{' '}
              </p>
              <small>
                <strong>
                  Intestario/Cointestatario:
                  <br className={'only-mobile'} />{' '}
                  {'name' in this.props.customer &&
                  this.props.customer.nome !== null
                    ? this.props.customer.nome.concat(
                        ' '.concat(this.props.customer.cognome)
                      )
                    : ''}
                </strong>
              </small>
              <br />
              <div className="relative-input">
                <BuyTextInput
                  classes="input-data form-input big uppercase"
                  defaultValue={compass.iban}
                  label={'IBAN'}
                  placeholder={"Scrivi l'IBAN"}
                  type={'text'}
                  update={this.handleInput('iban', this.props.compassUpdate)}
                />
              </div>
            </li>
          )}

          {this.props.compass.tipo_conto_corrente !== 'NES' && (
            <li className="wide buttons">
              <a
                className="btn btn-primary js-next-step"
                onClick={this.handleNext('conto_corrente')}
              >
                <span>Prosegui</span>
              </a>
            </li>
          )}

          <li className="wide buttons">
            <a className="btn btn-back js-back-step" onClick={this.handlePrev}>
              Indietro
            </a>
          </li>
        </BuyDataForm>
        <BuyDataForm
          active={this.state.section === 5}
          icon="check-bold"
          name="section-5"
          title="Privacy"
        >
          <li
            className={`${this.state.dati_compass_privacy_obbligatoria_1_mag2018_error} wide`}
          >
            <label>Consensi al trattamento dei dati personali</label>
            <div className="informativa">
              <p>
                Preso atto dell'informativa resami da Compass Banca S.p.A. ai
                sensi del Regolamento UE 2016/679 e della normativa nazionale
                vigente in materia di protezione dei dati personali:
              </p>
              <label className="r-checkbox radio">
                <input
                  defaultChecked={compass.privacy_obbligatoria_1_mag2018 == '1'}
                  name="privacy_obbligatoria_1_mag2018"
                  onChange={this.handleRadio(
                    'privacy_obbligatoria_1_mag2018',
                    this.props.compassUpdate
                  )}
                  type="radio"
                  // eslint-disable-next-line
                  value="1"
                />
                <span className="radio"></span>
                Acconsento
              </label>
              <label className="r-checkbox radio">
                <input
                  defaultChecked={compass.privacy_obbligatoria_1_mag2018 == '0'}
                  name="privacy_obbligatoria_1_mag2018"
                  onChange={this.handleRadio(
                    'privacy_obbligatoria_1_mag2018',
                    this.props.compassUpdate
                  )}
                  type="radio"
                  // eslint-disable-next-line
                  value="0"
                />
                <span className="radio"></span>
                Non acconsento
              </label>

              <p className="add-bullet-point">
                che, ai sensi dell’
                <a
                  href="https://www.compass.it/share/pdfs/COM087FART135.pdf#scrollbar=0&toolbar=0&statusbar=0&messages=0&navpanes=0"
                  rel="noreferrer"
                  target="_blank"
                >
                  art. 13 del Regolamento UE 2016/679
                </a>{' '}
                e della normativa nazionale vigente in materia di protezione dei
                dati personali:{' '}
              </p>
              <p className="add-padding-left">
                i) i miei dati personali, ivi inclusi quelli sensibili, siano
                trattati da Compass e comunicati a terzi (e da questi trattati),
                per le finalità ivi indicate alla lettere a) e d);
              </p>
              <p className="add-padding-left">
                ii) Compass acquisisca dalle società del Gruppo Mediobanca, che
                quindi potranno trasmettere, i dati relativi all’andamento dei
                rapporti eventualmente intercorrenti con queste ultime e li
                tratti per finalità strettamente connesse alla valutazione del
                merito creditizio della presente richiesta o per la valutazione
                di un nuovo rapporto;
              </p>
              <p className="add-bullet-point">
                che, in base all’art. 5 del “Codice di deontologia e di buona
                condotta per i sistemi informativi gestiti da soggetti privati
                in tema di crediti al consumo, affidabilità e puntualità nei
                pagamenti” riportata in questo contratto, i propri dati
                personali siano trattati da Compass e comunicati a terzi (e da
                questi trattati), per le finalità ivi indicate.
              </p>
            </div>
          </li>

          <li
            className={`${this.state.dati_compass_privacy_facoltativa_1_error} wide`}
            style={{ borderTop: '1px solid #ddd', paddingTop: '10px' }}
          >
            <div className="informativa">
              <p>
                Preso atto dell'informativa resami da Compass Banca S.p.A. ai
                sensi dell'
                <a
                  href="https://www.compass.it/share/pdfs/COM087FART135.pdf#scrollbar=0&toolbar=0&statusbar=0&messages=0&navpanes=0"
                  rel="noreferrer"
                  target="_blank"
                >
                  art. 13 del Regolamento UE 2016/679
                </a>{' '}
                e della normativa nazionale vigente in materia di protezione dei
                dati personali
              </p>
              <label className="r-checkbox radio">
                <input
                  defaultChecked={compass.privacy_facoltativa_1 == '1'}
                  name="privacy_facoltativa_1"
                  onChange={this.handleRadio(
                    'privacy_facoltativa_1',
                    this.props.compassUpdate
                  )}
                  type="radio"
                  //  eslint-disable-next-line
                  value="1"
                />
                <span className="radio"></span>
                Acconsento
              </label>
              <label className="r-checkbox radio">
                <input
                  defaultChecked={compass.privacy_facoltativa_1 == '0'}
                  name="privacy_facoltativa_1"
                  onChange={this.handleRadio(
                    'privacy_facoltativa_1',
                    this.props.compassUpdate
                  )}
                  type="radio"
                  //  eslint-disable-next-line
                  value="0"
                />
                <span className="radio"></span>
                Non acconsento
              </label>
              <p className="long">
                che i miei dati personali, ivi inclusi i dati relativi
                all’andamento dei rapporti e i dati relativi all’esposizione,
                anche nei confronti delle Società del Gruppo Mediobanca, siano
                trattati da Compass e da Società appartenenti al Gruppo
                Mediobanca (direttamente o per il tramite di outsourcers
                specializzati), per la finalità indicata alle lettera b) in
                relazione ai prodotti e servizi propri e di terzi. Tale consenso
                comprende altresì il consenso al trattamento dei propri dati
                personali mediante l'utilizzo di strumenti, anche informatici,
                per verificare la coerenza dei prodotti offerti, in adempimento
                alle disposizioni di vigilanza.
              </p>
            </div>
          </li>

          <li
            className={`${this.state.dati_compass_privacy_facoltativa_2_error} wide`}
          >
            <div className="informativa" style={{ paddingTop: '10px' }}>
              <label className="r-checkbox radio">
                <input
                  defaultChecked={compass.privacy_facoltativa_2 == '1'}
                  name="privacy_facoltativa_2"
                  onChange={this.handleRadio(
                    'privacy_facoltativa_2',
                    this.props.compassUpdate
                  )}
                  type="radio"
                  //  eslint-disable-next-line
                  value="1"
                />
                <span className="radio"></span>
                Acconsento
              </label>
              <label className="r-checkbox radio">
                <input
                  defaultChecked={compass.privacy_facoltativa_2 == '0'}
                  name="privacy_facoltativa_2"
                  onChange={this.handleRadio(
                    'privacy_facoltativa_2',
                    this.props.compassUpdate
                  )}
                  type="radio"
                  //  eslint-disable-next-line
                  value="0"
                />
                <span className="radio"></span>
                Non acconsento
              </label>
              <p className="long">
                che i miei dati personali siano trattati da Compass, per la
                finalità indicata alla lettera e), ovvero, per svolgere attività
                di profilazione consistente nella individuazione di preferenze,
                gusti, abitudini, necessità e scelte di consumo e nella
                definizione del profilo dell'interessato, in modo da migliorare
                i prodotti o servizi offerti e soddisfare le esigenze
                dell'interessato medesimo, nonché per effettuare, previo lo
                specifico consenso, comunicazioni a carattere promozionale,
                pubblicitario o commerciale personalizzate, con i mezzi indicati
                nell'informativa.
              </p>
            </div>
          </li>

          <li
            className={`${this.state.dati_compass_privacy_facoltativa_3_error} wide`}
          >
            <div className="informativa" style={{ paddingTop: '10px' }}>
              <label className="r-checkbox radio">
                <input
                  defaultChecked={compass.privacy_facoltativa_3 == '1'}
                  name="privacy_facoltativa_3"
                  onChange={this.handleRadio(
                    'privacy_facoltativa_3',
                    this.props.compassUpdate
                  )}
                  type="radio"
                  //  eslint-disable-next-line
                  value="1"
                />
                <span className="radio"></span>
                Acconsento
              </label>
              <label className="r-checkbox radio">
                <input
                  defaultChecked={compass.privacy_facoltativa_3 == '0'}
                  name="privacy_facoltativa_3"
                  onChange={this.handleRadio(
                    'privacy_facoltativa_3',
                    this.props.compassUpdate
                  )}
                  type="radio"
                  //  eslint-disable-next-line
                  value="0"
                />
                <span className="radio"></span>
                Non acconsento
              </label>
              <p className="long">
                che i miei dati personali siano comunicati a e trattati da
                Società terze per la finalità indicata alla lettera c) per
                prodotti o servizi da queste ultime offerti. Tale consenso
                comprende altresì il consenso al trattamento dei propri dati
                personali mediante l'utilizzo di strumenti, anche informatici ,
                per verificare la coerenza dei prodotti offerti, se ed entro gli
                stretti limiti in cui ciò è prescritto dalle disposizioni di
                vigilanza.
              </p>
            </div>
          </li>

          <li
            className={`${this.state.dati_compass_presa_visione_obbligatoria_error} wide`}
            style={{ borderTop: '1px solid #ddd', paddingTop: '10px' }}
          >
            <h4>Presa visione</h4>
            <label className="r-checkbox list long">
              <input
                defaultChecked={compass.presa_visione_obbligatoria == '1'}
                name="presa_visione_obbligatoria"
                onChange={this.handleCheckbox(
                  'presa_visione_obbligatoria',
                  this.props.compassUpdate
                )}
                type="checkbox"
                //  eslint-disable-next-line
                value="1"
              />
              <span className="check"></span>
              Inviando la richiesta (l’accettazione della quale è subordinata
              all’approvazione di Compass Banca S.p.A.) il richiedente dichiara:
              <ul>
                <li>
                  di aver preso visione del modulo “Informazioni europee di base
                  sul credito ai consumatori”
                </li>
                <li>
                  di aver preso visione dell’
                  <a
                    className="modal-btn"
                    data-modal="compass_4_pdf"
                    href="https://www.compass.it/share/pdfs/COM087FART135.pdf#scrollbar=0&toolbar=0&statusbar=0&messages=0&navpanes=0"
                    rel="noreferrer"
                    target="_blank"
                  >
                    informativa art. 13 del Regolamento UE 2016/679 e
                    dell’informativa ex. art 5 del Codice Deontologico sui
                    sistemi di informazioni creditizie
                  </a>
                </li>
                <li>
                  di aver preso visione della{' '}
                  <a
                    className="modal-btn"
                    data-modal="compass_2_pdf"
                    href="https://www.compass.it/share/pdfs/Guida_ABF.pdf#scrollbar=0&toolbar=0&statusbar=0&messages=0&navpanes=0"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Guida all’Arbitro Bancario e Finanziario
                  </a>
                </li>
                <li>
                  di aver preso visione della{' '}
                  <a
                    className="modal-btn"
                    data-modal="compass_3_pdf"
                    href="https://www.compass.it/share/pdfs/guida%20credito_compass.pdf#scrollbar=0&toolbar=0&statusbar=0&messages=0&navpanes=0"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Guida "Il credito ai consumatori in parole semplici"
                  </a>
                </li>
                <li>
                  di essersi avvalso di ottenere la{' '}
                  <a
                    className="modal-btn"
                    data-modal="compass_1_pdf"
                    href="https://www.compass.it/share/pdfs/COM282.pdf#scrollbar=0&toolbar=0&statusbar=0&messages=0&navpanes=0"
                    rel="noreferrer"
                    target="_blank"
                  >
                    copia contrattuale idonea per la stipula
                  </a>
                </li>
              </ul>
            </label>
          </li>

          <li
            className={`${this.state.dati_compass_condizioni_brumbrum_obbligatorie_error} wide`}
          >
            <label className="r-checkbox long">
              <input
                defaultChecked={compass.condizioni_brumbrum_obbligatorie == '1'}
                name="condizioni_brumbrum_obbligatorie"
                onChange={this.handleCheckbox(
                  'condizioni_brumbrum_obbligatorie',
                  this.props.compassUpdate
                )}
                //  eslint-disable-next-line
                type="checkbox"
              />
              <span className="check"></span>
              Ho preso visione e accetto le{' '}
              <a
                className="modal-btn"
                data-modal="condizioni-contratto"
                onClick={e => {
                  e.preventDefault()
                  e.stopPropagation()
                  this.setState({
                    show_condizioni_generali_di_contratto_modal: true,
                  })
                }}
              >
                Condizioni Generali di Contratto
              </a>{' '}
              del sito web brumbrum.it
            </label>
          </li>
          {haGaranzia3Anni(this.props.garanzia) && (
            <li
              className={`${this.state.dati_cliente_informativa_trattamento_dati_personali_garanzia_error} wide`}
            >
              <label className="r-checkbox long">
                <input
                  defaultChecked={
                    !!(
                      customer.informativa_trattamento_dati_personali_garanzia ===
                        1 ||
                      customer.informativa_trattamento_dati_personali_garanzia ===
                        '1'
                    )
                  }
                  name="informativa_trattamento_dati_personali_garanzia"
                  onChange={this.handleCheckbox(
                    'informativa_trattamento_dati_personali_garanzia'
                  )}
                  type="checkbox"
                />
                <span className="check"></span>
                Ho preso visione e accetto il{' '}
                <a
                  href={mapfreProgrammaGaranzia}
                  rel="noreferrer"
                  target="_blank"
                >
                  Programma di Garanzia Convenzionale
                </a>
                , il{' '}
                <a
                  href={mapfreAssistenzaStradale}
                  rel="noreferrer"
                  target="_blank"
                >
                  Programma di Assistenza Stradale
                </a>{' '}
                e l'
                <a
                  href={mapfreInformativaDatiPersonali}
                  rel="noreferrer"
                  target="_blank"
                >
                  Informativa sul trattamento dei dati personali
                </a>{' '}
                del gestore del programma di garanzia
              </label>
            </li>
          )}

          <li className="wide buttons">
            <a
              className={`btn btn-primary js-next-step${
                this.props.fetching ? ' btn-disabled' : ''
              }`}
              onClick={this.handleNext('privacy')}
            >
              <span>Prosegui</span>
            </a>
          </li>
          <li className="wide buttons">
            <a className="btn btn-back js-back-step" onClick={this.handlePrev}>
              Indietro
            </a>
          </li>
        </BuyDataForm>

        <DocumentiHelperModal
          display={this.state.show_condizioni_generali_di_contratto_modal}
          iframeSrc={`https://files.develop.brumbrum.it/pdf/brumbrum-CGC_v16112022.pdf`}
          modalTitle="Condizioni Generali di Contratto"
          onClose={() => {
            this.setState({
              show_condizioni_generali_di_contratto_modal: false,
            })
          }}
        />

        <BuyTerminiDiUtilizzo
          display={this.state.show_termini_di_utilizzo_modal}
          onClose={() => {
            this.setState({ show_termini_di_utilizzo_modal: false })
          }}
        />
      </form>
    )
  }
}

const mapStateToProps = state => ({
  customer: state.customer,
  compass: state.compass,
  compass_tabelledominio: state.compass_tabelledominio,
  ordine: state.ordine,
  comuni: state.comuni,
  fetching: state.ui.fetching,
  financements: state.financements,
  ui: state.ui,
  product: state.product,
  error: state.error,
  garanzia: state.garanzia,
})

export default connect(mapStateToProps, {
  customerUpdate,
  compassUpdate,
  reroute,
  putCompass,
  putClienti,
  putClientiCallback,
  putComapassCallback,
  storeDumpItForce,
  getTabelleDominioCompass,
  getTabelleDominioCompassCallbackSettoreAttivita,
  getTabelleDominioCompassCallbackOccupazioneAttivita,
  privacyUpdate,
  phaseChange,
})(BuyDataFormFinancement)
